module.exports = __webpack_public_path__ + "img/silent_call.7989f3d1.png";